import { Button } from "antd";
import { Link } from "react-router-dom";
import { SwiperSlide, Swiper } from "swiper/react";
import { Autoplay } from "swiper";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/superAdmin/login.css";
import { useRef } from "react";
import { useLoginValidator } from "../../redux/hooks/superAdminCustomHooks/hooks";
import {
  updateLoggedinState,
  updateLoginForm,
} from "../../redux/Admin/adminActions";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { set } from "lodash";
import LoadingSpinner from "../UI/superAdmin/loaders/LoadingSpinner";
import SuccessPopup from "../UI/superAdmin/modals/SuccessModal";
import ErrorPopup from "../UI/superAdmin/modals/ErrorModal";

const slides = [
  {
    image: "/assets/superAdmin/slider_img1.svg",
    title: "Add Client",
    description: "Manage your clients efficiently",
  },
  {
    image: "/assets/superAdmin/slider_img2.svg",
    title: "Extend Subscriptions",
    description: "Streamlined administrative controls",
  },
  {
    image: "/assets/superAdmin/slider_img3.svg",
    title: "Add Module",
    description: "Streamlined administrative controls",
  },

  {
    image: "/assets/superAdmin/slider_img4.svg",
    title: "Revenue Analytics",
    description: "Streamlined administrative controls",
  },
];

const ForgotPassword = () => {
  const passwordRef = useRef(null);
  const usernameRef = useRef(null);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/super-admin/forgot-password`,
          {
            email
          }
        );

        setSuccessMessage(response.data.message);
        
        setIsLoading(false);
       
      
    } catch (error) {
      setIsLoading(false);
      setErrorMessage(error?.response.data.message);
      return;
    }
  };

  return (
    <>
      {successMessage && (
        <SuccessPopup
          message={successMessage}
          onClose={() => setSuccessMessage(null)}
        />
      )}
      {errorMessage && (
        <ErrorPopup
          message={errorMessage}
          onClose={() => setErrorMessage(null)}
        />
      )}
      <div className="login">
        <div className="login-wrapper">
          {/* Left Section */}
          <div className="left-section d-lg-flex d-none">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              pagination={{ clickable: true }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              className="login-slider"
            >
              {slides.map((slide, index) => (
                <SwiperSlide key={index}>
                  <div className="slide-content">
                    <img
                      src={slide.image || "/placeholder.svg"}
                      alt={slide.title}
                      className="slide-image"
                    />
                    <h3>{slide.title}</h3>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Right Section */}
          <div className="right-section">
            <div className="login-content">
              <h1>SSL Super Admin Management</h1>
              <p>
                All Super administrative actions managed from one account to
                make management easier
              </p>

              <form className="super_loginForm" onSubmit={handleSubmit}>
                <h2>Forgot Password</h2>
                <div className="form-wrapper">
                  <div className="input-group">
                    <label htmlFor="username">Email:</label>
                    <input
                      type="email"
                      id="email"
                      className="form-input"
                      ref={usernameRef}
                      onChange={(e) => setEmail(e.target.value)}
                      name="email"
                      value={email}
                      placeholder="Input your email"
                    />
                   
                  </div>


                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    className="proceed-btn"
                    isLoading={isLoading}
                  >
                    {isLoading ? <LoadingSpinner /> : "Get Reset Email"}
                  </Button>
                </div>
              </form>
              <div className="privacy-link">
                <Link to="#">Privacy</Link>
                <span className="separator">|</span>
                <Link to="#">Terms & conditions</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgotPassword;
